import {FunctionComponent} from 'react';
import Table from '@/components/table';
import {TABLE_THEME} from '@/constants/table';

const Tables: FunctionComponent = () => {
  const data = {
    headers: ['Type de rangée', 'Rachetable ou non', 'Date d’échéance'],
    body: [
      {columns: ['Default', 'Rachetable', 'À la réception du formulaire']},
      {columns: ['Default', 'Non rachetable', '24 mai 2027']},
      {columns: ['Disabled', 'Rachetable', 'À la réception du formulaire'], disabled: true},
      {columns: ['Disabled', 'Non rachetable', '24 mai 2027'], disabled: true},
      {columns: ['Clickable', 'Rachetable', '31 juin 2029'], onClick: (): void => undefined},
      {columns: ['Clickable', 'Non rachetable', '24 mai 2027'], onClick: (): void => undefined},
      {columns: ['En erreur', 'Rachetable', '31 juin 2029'], isError: true},
      {columns: ['En erreur', 'Non rachetable', '24 mai 2027'], isError: true},
    ],
  };

  return (
    <div className="flex flex-col gap-7">
      <div>
        <h3 className="mb-2 text-lg font-medium text-charcoal">Primaire</h3>
        <Table data={data} dataTestid="demo-primary-table" />
      </div>

      <div>
        <h3 className="mb-2 text-lg font-medium text-charcoal">Secondaire</h3>
        <Table theme={TABLE_THEME.SECONDARY} data={data} dataTestid="demo-secondary-table" />
      </div>
    </div>
  );
};

export default Tables;
